import { Box } from "@mui/material";
import clsx from "clsx";
import { useContext } from "react";
import { DesignEditorContext } from "../../../../../contexts/DesignEditor.tsx";
import { useActiveObject } from "../../../../../hooks/useActiveObject.tsx";
import { OBJECT_TYPES } from "../../ContextMenu/ContextMenusData.tsx";
import EditAllAdsSwitch from "../../Panels/panelItems/Common/EditAllAdsSwitch/EditAllAdsSwitch";
import FabricObjectsProperties from "../../Panels/panelItems/Common/FabricObjectsProperties/FabricObjectsProperties.tsx";
import { ObjectsEnum } from "../../Panels/panelItems/index.ts";
import styles from "./Multiple.module.scss";

export default function () {
	const { isPopupView } = useContext(DesignEditorContext);
	const activeObject = useActiveObject() as any;

	if (isPopupView) {
		return null;
	}

	// Show FabricObjectsProperties only when group contains inner or outer rectangle
	const showFabricObjectsProperties =
		activeObject?.name === OBJECT_TYPES.GROUP &&
		activeObject._objects &&
		activeObject._objects.length >= 2 &&
		activeObject._objects.some(
			(obj: fabric.Object) => obj.id === ObjectsEnum.InnerRectangle || obj.id === ObjectsEnum.OuterRectangle,
		);

	return (
		<>
			<Box
				className={clsx({
					[styles.textControls]: true,
					[styles.hide]: isPopupView,
				})}
			>
				<Box className={styles.groupControlsWrapper}>
					{showFabricObjectsProperties && <FabricObjectsProperties />}
				</Box>
				<EditAllAdsSwitch />
			</Box>
		</>
	);
}
